"use client";

import { useContext } from "react";
import Script from "next/script";
import { UserContext } from "@/contexts/user-context";

export const Analytics = () => {
  const { isLoggedIn, isBusinessUser } = useContext(UserContext);

  return (
    <Script id={"cookies-analytics"} strategy={"afterInteractive"}>
      {`
        let isAnalytics = ${
          isLoggedIn || isBusinessUser
            ? `"1"`
            : "localStorage.getItem('analytics')"
        };
                
        if (isAnalytics === null) {
          localStorage.setItem('analytics', '0');
          isAnalytics = '0';
        }
      `}
    </Script>
  );
};
